/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a YouTube link or video ID…`)
};

const es_yt_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega un enlace de YouTube o el ID del video…`)
};

const de_yt_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube-Link oder Video-ID einfügen…`)
};

const nl_yt_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een YouTube-link of video-ID…`)
};

const fr_yt_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez un lien YouTube ou un ID de vidéo…`)
};

const it_yt_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un link YouTube o l'ID del video…`)
};

const pt_br2_yt_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um link do YouTube ou o ID do vídeo…`)
};

const pt_yt_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um link do YouTube ou o ID do vídeo…`)
};

const ja_yt_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeのリンクまたは動画IDを貼り付け…`)
};

const zh_yt_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴 YouTube 链接或视频 ID…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_input_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_input_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_input_placeholder", locale)
	if (locale === "en") return en_yt_input_placeholder(inputs)
	if (locale === "es") return es_yt_input_placeholder(inputs)
	if (locale === "de") return de_yt_input_placeholder(inputs)
	if (locale === "nl") return nl_yt_input_placeholder(inputs)
	if (locale === "fr") return fr_yt_input_placeholder(inputs)
	if (locale === "it") return it_yt_input_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_yt_input_placeholder(inputs)
	if (locale === "pt") return pt_yt_input_placeholder(inputs)
	if (locale === "ja") return ja_yt_input_placeholder(inputs)
	return zh_yt_input_placeholder(inputs)
};